export { ZORA_COMPONENT_REGISTRY } from './ZORA_COMPONENT_REGISTRY';
